import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import classnames from 'classnames';
import { Col, Overlay, Popover } from 'bootstrap';
import PopoverStore from 'shared/flux/stores/PopoverStore';
import PopoverActions from 'shared/flux/actions/PopoverActions';

export default React.createClass({
  displayName: 'GeneralPopover',

  mixins: [Reflux.connect(PopoverStore, 'popoverVisibility')],

  propTypes: {
    display: React.PropTypes.bool,
    displayNode: React.PropTypes.object.isRequired,
    popoverId: React.PropTypes.string.isRequired,
    hideOnMouseLeave: React.PropTypes.bool,
    showOnMouseEnter: React.PropTypes.bool,
    classes: React.PropTypes.string,
    inline: React.PropTypes.bool,
  },

  getDefaultProps() {
    return {
      display: false,
      placement: 'bottom',
      hideOnMouseLeave: true,
      showOnMouseEnter: false,
    };
  },

  render() {
    let displayNodeProps = {
      ref: 'target',
      onClick: (e) => {
        e.stopPropagation();
        PopoverActions.show(this._getPopoverId());
      },
    };

    if (!this.props.inline) {
      displayNodeProps.style = { display: 'block' };
    }

    if (this.props.showMouseOnEnter) {
      displayNodeProps.onMouseEnter = () =>
        PopoverActions.show(this._getPopoverId());
    }

    return (
      <div>
        <span {...displayNodeProps}>{this.props.displayNode}</span>
        <Overlay
          rootClose
          show={
            this.props.display ||
            this.state.popoverVisibility.get(this._getPopoverId())
          }
          onHide={this._handleHide}
          placement={this.props.placement}
          container={document.body}
          target={() => ReactDOM.findDOMNode(this.refs.target)}
        >
          {this._getPopoverNode()}
        </Overlay>
      </div>
    );
  },

  _getPopoverNode() {
    return (
      <Popover className={classnames('general-popover', this.props.classes)}>
        <Col onMouseLeave={this._handleHide} lg={24}>
          {this.props.children}
        </Col>
      </Popover>
    );
  },

  _getPopoverId() {
    return this.props.popoverId;
  },

  _handleHide() {
    if (this.props.hideOnMouseLeave) PopoverActions.hide(this._getPopoverId());
  },
});
